import { compose, withHandlers } from 'recompose';
import { connect } from 'react-redux';
import { change, formValueSelector } from 'redux-form';
import { getShopBookNoPay } from '../../../../settings/barberSettings/selectors';
import { canUsePasscode } from '../../../../../auth/selectors';
import { FORM } from '../constants';
import { calculateHourlyWagesEnabled, extendedHourlyWagesEnabled } from '../../../../timeTracker/selectors';
import { flagNames, withInjectFeatureFlagsToProps } from '../../../../../../modules/infra/feature-flags';

const selector = formValueSelector('barberForm');

const BarberFormContainer = compose(
  connect(
    state => ({
      user: state.auth.user,
      barberUser: state.auth.barberUser,
      permissions: state.auth.permissions,
      shopBookNoPay: getShopBookNoPay(state),
      canUsePasscode: canUsePasscode(state),
      canCustomerCancel: selector(state, 'canCustomerCancel'),
      calculateHourlyWagesEnabled: calculateHourlyWagesEnabled(state),
      extendedHourlyWagesEnabled: extendedHourlyWagesEnabled(state),
    }),
    { change }
  ),
  withHandlers({
    change: props => (...args) => props.change(FORM, ...args),
  }),
  withInjectFeatureFlagsToProps([flagNames.HYBRID_STAFF_PAYMENTS_TAB])
);

export default BarberFormContainer;
